import React from "react";
import { useStaticQuery, graphql } from "gatsby";

const ThreeColumnSection = ({ headingLevel, className }) => {
  const data = useStaticQuery(graphql`
    {
      icon1: file(relativePath: { eq: "1.0 Homepage/ThreeColumn/Icon 1.svg" }) {
        publicURL
      }
      icon2: file(relativePath: { eq: "1.0 Homepage/ThreeColumn/Icon 2.svg" }) {
        publicURL
      }
      icon3: file(relativePath: { eq: "1.0 Homepage/ThreeColumn/Icon 3.svg" }) {
        publicURL
      }
      line: file(relativePath: { eq: "1.0 Homepage/dotted-line.svg" }) {
        publicURL
      }
    }
  `);

  const HeadingTag = headingLevel || "h2";

  const content = [
    {
      icon: data.icon1.publicURL,
      heading: "Instantly review business data",
      text: "See in a real-time dashboard where the holes are in your business and which levers you need to pull.",
    },
    {
      icon: data.icon2.publicURL,
      heading: "Make informed decisions",
      text: "Stop wasting money on leads that don’t close or agents that don’t perform. Know when to pivot.",
    },
    {
      icon: data.icon3.publicURL,
      heading: "Accelerate growth",
      text: "Find out what’s hindering you and double down on the strategies that work so you can grow faster.",
    },
  ];

  return (
    <section className={`${className || "mb-20 md:mb-32"}`}>
      <div className="container mx-auto max-w-[1267px]">
        <header className="mx-auto mb-12 max-w-[680px] text-center md:mb-20">
          <HeadingTag>Maximize Profitability</HeadingTag>
        </header>

        <div className="relative z-10 grid gap-y-12 md:grid-cols-3 md:gap-x-10 lg:gap-x-20">
          {content.map((content, i) => {
            return (
              <div key={i} className="text-center">
                <img
                  src={content.icon}
                  alt={content.heading}
                  className="mx-auto mb-10"
                />
                <div>
                  <h3 className="heading-four mb-3">{content.heading}</h3>
                  <p className="mb-0">{content.text}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ThreeColumnSection;
